import { useQuery } from '@tanstack/react-query';
import { fetchJson } from '../lib/api';

export interface DashboardStats {
  contactsCount: number;
  organizationsCount: number;
  openDeals: number;
  pendingTasks: number;
  recentActivity: ActivityItem[];
}

export interface ActivityItem {
  id: string;
  type: string;
  description: string;
  entityType?: string;
  entityId?: string;
  entityName?: string;
  createdAt: string;
  userId?: string;
  userName?: string;
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: () => fetchJson<DashboardStats>('/api/dashboard/stats'),
    staleTime: 60_000,
  });
}
